import { supabase } from "../constants";

// Llamada al proxy de Anthropic (/api/anthropic) con la sesión del usuario.
// El proxy rechaza cualquier llamada sin sesión (401) y limita las llamadas
// por usuario (429). Mismo uso que fetch: devuelve la Response.
//   const res = await aiFetch({ method: "POST", headers: {...}, body: JSON.stringify({...}) });
export const aiFetch = async (init = {}) => authFetch("/api/anthropic", init);

// Cualquier ruta propia que exige sesión (send-email, send-intake-email…):
// mismo uso que fetch, añade el JWT. POST por defecto.
export const authFetch = async (url, init = {}) => {
  const { data: { session } } = await supabase.auth.getSession();
  return fetch(url, {
    method: "POST",
    ...init,
    headers: { "Content-Type": "application/json", ...(init.headers || {}), Authorization: `Bearer ${session?.access_token || ""}` },
  });
};
